import { Form, FormItemProps, Input } from 'antd';
import { TextAreaProps } from 'antd/lib/input';
import { useEffect, useState } from 'react';

interface Props extends TextAreaProps {
  value?: any;
  readonly label?: string;
  readonly errorMessage?: string;
  readonly formItemProps?: FormItemProps;
}

const { TextArea } = Input;

export const AntTextarea = ({
  style,
  id,
  label,
  value,
  errorMessage,
  placeholder,
  disabled,
  formItemProps,
  onChange,
  ...props
}: Props) => {
  const [inputValue, setInputValue] = useState<any>();

  useEffect(() => {
    setInputValue(value ?? '');
  }, [value]);

  return (
    <Form.Item
      label={label}
      {...formItemProps}
      style={style}
      htmlFor={id}
      help={errorMessage}
      validateStatus={errorMessage ? 'error' : undefined}
    >
      <TextArea
        {...props}
        id={id}
        allowClear
        style={{ height: 75 }}
        onChange={onChange}
        placeholder={placeholder}
        value={inputValue}
        disabled={disabled}
      />
    </Form.Item>
  );
};
